var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import axios from 'axios';
const defaultOptions = {
    headers: {
        accept: 'application/json',
        'accept-encoding': 'utf8',
        'content-type': 'application/json',
    },
    // credentials: 'same-origin',
};
export const isomorphicFetchWrapper = (_a) => {
    var { body, data = body, url, headers = {} } = _a, requestParams = __rest(_a, ["body", "data", "url", "headers"]);
    const opts = Object.assign(Object.assign(Object.assign(Object.assign({}, defaultOptions), requestParams), { headers: Object.assign(Object.assign({}, defaultOptions.headers), headers), url }), (data && { data }));
    return axios(opts)
        .then(({ data }) => data)
        .catch(({ response, message }) => {
        var _a, _b, _c;
        const body = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) !== null && _a !== void 0 ? _a : message) !== null && _b !== void 0 ? _b : {};
        return Promise.reject({
            body,
            response,
            status: (_c = response === null || response === void 0 ? void 0 : response.status) !== null && _c !== void 0 ? _c : 500,
        });
    });
};
//# sourceMappingURL=isomorphic-fetch-wrapper.js.map